<template>

  <v-container>

    <v-alert
      dense
      text
      type="success"
      v-if="message"
    >
    {{message}}
    </v-alert>

    <v-alert
      dense
      text
      type="warning"
      v-if="isDuplicate"
    >
    そのURLはすでに登録されています
    </v-alert>

      <v-row class="text-center">

        <v-col>

          <template>
            <form>
              <v-text-field
                v-model="inputUrl"
                label="URLを入力してください"
                required
                clearable
                @change="changeInputUrl"
              ></v-text-field>

              <v-btn
                class="mr-4"
                v-on:click="submit(inputUrl)"
              >
                登録する
              </v-btn>
            </form>
          </template>

          <p v-if="Object.keys(articles).length > 0"
            class="subheading font-weight-regular mt-6">
            現在登録されているオンラインコンテンツは{{Object.keys(articles).length}}件です。
          </p>
          <p v-else
            class="subheading font-weight-regular mt-6">
            読み込み中です。。。
          </p>

        </v-col>

      </v-row>

      <template>
        <v-container fluid>

          <v-row align="center">
            <v-col
              class="d-flex justify-center"
              cols="12"
              sm="3"
            />
            <v-col
              cols="12"
              sm="4">
              <v-combobox
                v-model="selectedArtists"
                :items="artists"
                label="アーティスト名を選択"
                multiple
                clearable
                chips
                @change="filterArticles"
              ></v-combobox>
            </v-col>
            <v-col
              class="d-flex justify-center"
              cols="12"
              sm="2"
            >
              <v-select
                :items="sortItems"
                label="並び順"
                @change="changedValue"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <v-row class="text-center">

        <!-- max-width="374" -->
        <v-card
          class="mx-auto my-1 col-lg-3 col-md-4 col-sm-12"
          max-width="374"
          v-for="(article, index) in articles"
          :key="index"
          >
          <!-- :loading="loading" -->

          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img
            v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
            height="190"
            :src="article.ogimage"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div v-if="article.siteName ==='Twitter'">
            <Tweet :id="getTweetId(article.url)"
              error-message="This tweet could not be loaded"
              error-message-class="tweet--not-found">
              <div class="spinner"></div>
            </Tweet>
          </div>
          <div v-if="article.siteName ==='Facebook' && !isLocalhost()">
            <div class="fb-post" :data-href="article.url" data-width="330"></div>
          </div>

          <v-card-text>
            <div v-if="article.publishedAt">{{getPublishedAt(article.publishedAt)}}</div>

            <p
              v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
              class="text-h6 text-primary">
              {{article.title}}
            </p>

            <p v-if="article.siteName && article.siteName !=='Twitter'">{{article.siteName}}</p>

            <div v-if="article.siteName ==='note'">
              {{adjustLength(parseHtml(article.description))}}
            </div>
            <div v-else>
              {{adjustLength(article.description)}}
            </div>

            <p class="text-body2 my-2" v-if="article.duration">
              再生時間: {{getDuration(article.duration)}}
            </p>

          </v-card-text>

          <!-- <v-chip
            link
            class="ma-1"
            v-for="tag in article.tags"
            :key="tag">
            #{{tag}}
          </v-chip> -->

          <template>
            <v-combobox
              v-model="article.tags"
              label="アーティスト名"
              :items="artists"
              clearable
              dense
              multiple
              @change="setArtist(article, index)"
            >
            <!-- label="Your favorite hobbies" -->
            <!-- prepend-icon="mdi-filter-variant" -->
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  @click="select"
                  @click:close="remove(item)"
                >
                  {{ item }}&nbsp;
                  <!-- <strong>{{ item }}</strong>&nbsp; -->
                  <!-- <span>(interest)</span> -->
                </v-chip>
              </template>
            </v-combobox>
          </template>

          <v-switch
            inset
            @click="getSelectedItem(article.id, index)"
            @change="valueChange"
            v-if="article.siteName !=='Facebook' && article.siteName !=='Twitter'"
            :input-value="article.isFree"
            :label="`これは有料ですか？: ${getItemValue(article.isFree)}`"
          ></v-switch>

          <v-btn
            v-if="article.siteName !=='Twitter'"
            :href="article.url"
            target="_blank"
            block>
              開く
          </v-btn>

        </v-card>

      </v-row>

    <v-layout class="mt-6">
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-layout>
            <v-flex xs5>
              <v-img
                :src="publicPath + 'ogimage.jpg'"
                contain
                class="pl-4"
              ></v-img>
            </v-flex>
            <v-flex xs7>
              <v-card-title primary-title>
                <div>
                  <div class="headline">LINE公式アカウントやってます</div>
                  <!-- <div>お知らせを通知するよ</div> -->
                </div>
              </v-card-title>
              <v-card-actions>
                <v-btn
                  href="https://t.co/bpBeewt0vR"
                  target="_blank"
                  Block Button
                  color="orange">友達になる</v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-center mt-6">
      <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-text="アシオト - 日本のアイルランド音楽をオンラインで" data-url="https://ashioto-315.web.app/" data-via="アシオト" data-hashtags="アシオト" data-show-count="false" data-size="large">Tweet</a>
    </div>

    <!-- <v-row class="text-center my-6">
      <div class="col fb-page" data-href="https://www.facebook.com/ashioto0315/" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="false" data-hide-cover="true" data-show-facepile="true"><blockquote cite="https://www.facebook.com/ashioto0315/" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/ashioto0315/" target="_blank">アシオト連絡室</a></blockquote></div>
    </v-row> -->

  </v-container>
</template>

<script>

  import {db} from '../db.js'
  // import {twitterAPIInfo} from '../twitter.js'
  import YouTube from 'youtube-node'
  import moment from 'moment'

  moment.locale("ja")

  const youtubeKey = 'AIzaSyBcQy1t6Bzl9mXtTMtNtb2aCaQfiyJlFbw'
  const youtube = new YouTube()
  youtube.setKey(youtubeKey)

  import { Tweet } from 'vue-tweet-embed'

  // InstagramグラフAPI
  // https://developers.facebook.com/docs/instagram-api/?locale=ja_JP

  export default {
    name: 'HelloWorld',
    components: {
      Tweet
    },
    data: () => ({
      publicPath: process.env.BASE_URL,
      tab: "",
      sortItems: ['登録順', '公開日順'],
      isSelectedArticleFree: null,
      db: null,
      urls: {},
      inputUrl: "",
      message: "",
      isDuplicate: false,
      originalArticles: [],
      articles: [],
      selectedArtists: [],
      artists: [
        '大橋志麻',
        '石崎元弥',
        '小松大',
        '須貝知世',
        '高橋創',
        '瀧澤晴美',
        '豊田耕三'],
    }),
    created () {
      // Initialize Firebase

      let self = this
      db.ref('/articles').orderByChild('timestamp').once('value').then(function (articles) {
        // 素パースだと順序が決め打ちになってしまう
        // self.articles = articles.val()
        let _articles = articles.val()
        for (let index in _articles) {
          self.articles.push(_articles[index])
        }

        self.articles = self.articles.reverse()
        self.originalArticles = self.articles
        // console.log(self.articles)
      })
    },
    mounted () {
      let _this = this
      this.$nextTick(() => {
        window.fbAsyncInit = function () {

          window.FB.init({
            appId: '1530036100528440',
            xfbml: true,
            version: 'v3.2'
          })
          window.FB.AppEvents.logPageView()
          _this.FB = window.FB
          console.log('FB SDK was initialized as mixin')
          window.FB.XFBML.parse()
        };
        (function (d, s, id) {
          let js, fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) { return }
          js = d.createElement(s); js.id = id
          js.src = '//connect.facebook.net/en_US/sdk.js'
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'facebook-jssdk'))
      })

      // console.log(window.FB)
      // console.log(window.FB.XFBML)
      // window.FB.XFBML.parse()
    },
    updated: function () {
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
        // https://developers.facebook.com/docs/reference/javascript/FB.XFBML.parse/
        window.FB.XFBML.parse()
      })
    },
    methods: {
      isLocalhost () {
        return window.location.hostname === "localhost"
      },
      changeInputUrl () {
        this.isDuplicate = false
      },
      changedValue (value) {
        let self = this
        self.selectedArtists = []
        self.filterArticles()
        // console.log(value)
        // https://qiita.com/bbapexx/items/299521d49df0869dc44f
        db.ref('/articles').once('value').then(function (articles) {
          if (value === "登録順") {
            self.articles = []
            let _articles = articles.val()
            for (let index in _articles) {
              self.articles.push(_articles[index])
            }
            self.articles = self.articles.reverse()
            self.originalArticles = self.articles
          }
          else {
            self.articles = []
            let _articles = articles.val()
            for (let index in _articles) {
              if (_articles[index].publishedAt !== undefined) {
                self.articles.push(_articles[index])
              }
            }
            // https://qiita.com/PianoScoreJP/items/f0ff7345229871039672
            self.articles.sort(function(a, b){
              if (a.publishedAt < b.publishedAt) return -1
              if (a.publishedAt > b.publishedAt) return 1
              return 0
            })
            self.articles = self.articles.reverse()
            for (let index in _articles) {
              if (_articles[index].publishedAt === undefined) {
                self.articles.push(_articles[index])
              }
            }
            self.originalArticles = self.articles
          }

        })
      },
      filterArticles () {
        let self = this
        if (self.selectedArtists.length === 0) {
          self.articles = self.originalArticles
          return
        }

        self.articles = []
        for (let index in self.originalArticles) {
          let hit = true
          for (let sIndex in self.selectedArtists) {
            let artist = self.selectedArtists[sIndex]
            if (self.originalArticles[index].tags === undefined || self.originalArticles[index].tags.indexOf(artist) === -1) hit = false
            if (hit) self.articles.push(self.originalArticles[index])
          }
        }

      },
      getItemValue (bool) {
        return bool ? "はい" : "いいえ"
      },
      getSelectedItem (articleId, index) {
        // console.log(articleId, index, this.isSelectedArticleFree)
        let self = this
        self.articles[index].isFree = self.isSelectedArticleFree
        db.ref('/articles/' + articleId).set(self.articles[index]).then(function () {
        })
      },
      valueChange (value) {
        this.isSelectedArticleFree = value
      },
      adjustLength (description) {
        const descriptionLength = 140
        if (description && description.length > descriptionLength) {
          description = description.slice(0, descriptionLength) + '…'
        }
        return description
      },
      setArtist (articleInfo, index) {
        // console.log(articleInfo)
        let self = this
        self.articles[index].tags = articleInfo.tags
        db.ref('/articles/' + articleInfo.id).set(self.articles[index]).then(function () {
        })
      },
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
        this.chips = [...this.chips]
        this.articles = this.originalArticles
      },
      isYouTubePlaylist (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (url.indexOf("playlist") !== -1) {
          let id = parser.searchParams.get("list")
          return id
        }

        return false
      },
      getNoteId (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (parser.host === "note.com") {
          let id = parser.pathname.split('/').pop()
          return id
        }

        return false
      },
      isTwitter (url) {
        let parser = new URL(url)
        return parser.host === "twitter.com"
      },
      getTweetId (url) {
        let parser = new URL(url)
        return parser.pathname.split('/').pop()
      },
      isFacebook (url) {
        let parser = new URL(url)
        return parser.host === "www.facebook.com" || parser.host === "fb.watch"
      },
      parseHtml (html) {
        return html.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
      },
      getYouTubeId (url) {
        // https://qiita.com/edisonthk/items/9e76784bedbd0cb969a5
        let parser = new URL(url)

        if (url.indexOf("youtu.be") !== -1) {
          let id = parser.pathname.split('/').pop()
          return id
        }

        if (url.indexOf("playlist") !== -1) {
          let id = parser.searchParams.get("list")
          return id
        }

        if (parser.host === "youtube.com") {
          let id = parser.searchParams.get("v")
          return id
        }

        return false
      },
      getPublishedAt (publishedAt) {
        return moment(publishedAt).format('LL')
      },
      getDuration (duration) {
        return moment.duration(duration).humanize({precision: 2})
      },
      submit () {
        // console.log(this.inputUrl)

        for (let ai in this.articles) {
          if (this.inputUrl === this.articles[ai].url) this.isDuplicate = true
        }
        if (this.isDuplicate) {
          console.log('そのURLは登録されています')
          return false
        }

        let self = this
        // console.log(self.inputUrl)
        // console.log(self.getYouTubeId(self.inputUrl))

        const CORS_PROXY = 'https://cors-anywhere.herokuapp.com/'
        let url = CORS_PROXY + this.inputUrl

        let id = self.getYouTubeId(self.inputUrl)
        let playListId = self.isYouTubePlaylist(self.inputUrl)
        let noteId = self.getNoteId(self.inputUrl)
        if (playListId) {
          let yurl = "https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=" + playListId + "&maxResults=50&key=" + youtubeKey
          fetch(yurl).then(res => res.text()).then(text => {
            let json = JSON.parse(text)
            let title = "YouTubeの再生リスト"
            let playListCount = json.items.length
            let firstItem = json.items[0]
            let thumbnail = firstItem.snippet.thumbnails.high.url
            // let description = playListCount + "個の動画が登録されています"
            let description = playListCount + "件の動画が登録されています。" + firstItem.snippet.description

            let newCommentRef = db.ref('/articles').push()
            newCommentRef.set({
              id: newCommentRef.key,
              siteName: "YouTube",
              index: Date.parse(new Date()) * -1,
              type: "youtube",
              title: title,
              description: description,
              ogimage: thumbnail,
              url: self.inputUrl,
              timestamp: Date.parse(new Date())
            }).then(function () {
              self.message = title + " を登録しました"
              self.inputUrl = ""
              db.ref('/articles').once('value').then(function (articles) {
                let _articles = articles.val()
                for (let index in _articles) {
                  self.articles.push(_articles[index])
                }

                self.articles = self.articles.reverse()
              })
              self.articles = []
            })

          })
        }
        else if (noteId) {
          let nurl = CORS_PROXY + "https://note.com/api/v1/notes/" + noteId
          fetch(nurl).then(res => res.text()).then(text => {
            let json = JSON.parse(text)
            // console.log(json)
            let title = json.data.name
            let publishedAt = json.data.created_at
            let thumbnail = json.data.eyecatch !== undefined ? json.data.eyecatch : json.data.user.user_profile_image_path
            let description = json.data.body

            let newCommentRef = db.ref('/articles').push()
            newCommentRef.set({
              id: newCommentRef.key,
              siteName: "note",
              publishedAt: publishedAt,
              index: Date.parse(new Date()) * -1,
              type: "note",
              title: title,
              description: description,
              ogimage: thumbnail,
              url: self.inputUrl,
              timestamp: Date.parse(new Date())
            }).then(function () {
              self.message = title + " を登録しました"
              self.inputUrl = ""
              db.ref('/articles').once('value').then(function (articles) {
                let _articles = articles.val()
                for (let index in _articles) {
                  self.articles.push(_articles[index])
                }

                self.articles = self.articles.reverse()
              })
              self.articles = []
            })

          })

        }
        else if (this.isTwitter(self.inputUrl)) {

          let newCommentRef = db.ref('/articles').push()
          newCommentRef.set({
            id: newCommentRef.key,
            siteName: "Twitter",
            index: Date.parse(new Date()) * -1,
            type: "Twitter",
            // title: title,
            // description: description,
            // ogimage: ogimage,
            url: self.inputUrl,
            timestamp: Date.parse(new Date())
          }).then(function () {
            self.message = "ツイートを登録しました"
            self.inputUrl = ""
            db.ref('/articles').once('value').then(function (articles) {
              let _articles = articles.val()
              for (let index in _articles) {
                self.articles.push(_articles[index])
              }

              self.articles = self.articles.reverse()
            })
            self.articles = []
          })

        }
        else if (this.isFacebook(self.inputUrl)) {

          fetch(url).then(res => res.text()).then(text => {
              const el = new DOMParser().parseFromString(text, "text/html")
              const headEls = (el.head.children)

              let title = ""
              let description = ""
              let ogimage = ""

              Array.from(headEls).map(v => {

                const prop = v.getAttribute('property')
                if (!prop) return;
                const content = v.getAttribute('content')
                if (!content) return
                if (prop === "og:site_name") console.log(content)
                if (prop === "og:title" || prop === "twitter:title") title = content
                // if (prop === "og:image" || prop === "twitter:card") title = content
                if (prop === "og:image") ogimage = content
                if (prop === "og:description" || prop === "twitter:description") description = content

              })

              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                siteName: "Facebook",
                index: Date.parse(new Date()) * -1,
                type: "Facebook",
                title: title,
                description: description,
                ogimage: ogimage,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

            })
        }
        else if (id) {
          youtube.getById(id, function(error, result) {
            if (error) {
              console.log(error)
            }
            else {
              // console.log(result)
              // console.log(data.items)
              // console.log(item.thumbnails.default.url)

              let item = result.items[0]
              // console.log(publishedAt)
              // console.log(duration)
              // console.log(convertDuration)
              let title = item.snippet.title
              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                siteName: "YouTube",
                publishedAt: item.snippet.publishedAt,
                index: Date.parse(new Date()) * -1,
                type: "youtube",
                title: item.snippet.title,
                description: item.snippet.description,
                ogimage: item.snippet.thumbnails.high.url,
                duration: item.contentDetails.duration,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

            }
          })
        }
        else {
          // https://qiita.com/ksyunnnn/items/bfe2b9c568e97bb6b494
          fetch(url).then(res => res.text()).then(text => {
              const el = new DOMParser().parseFromString(text, "text/html")
              const headEls = (el.head.children)

              let type = ""
              let title = ""
              let description = ""
              let ogimage = ""

              Array.from(headEls).map(v => {

                // console.log(v)
                const prop = v.getAttribute('property')
                if (!prop) return;
                // console.log(prop)
                const content = v.getAttribute('content')
                if (!content) return
                // console.log(content)
                if (prop === "og:site_name") console.log(content)
                if (prop === "og:type") type = content
                if (prop === "og:title" || prop === "twitter:title") title = content
                // if (prop === "og:image" || prop === "twitter:card") title = content
                if (prop === "og:image") ogimage = content
                if (prop === "og:description" || prop === "twitter:description") description = content

              })

              // console.log(type, title, description, ogimage)

              let newCommentRef = db.ref('/articles').push()
              newCommentRef.set({
                id: newCommentRef.key,
                index: Date.parse(new Date()) * -1,
                type: type,
                title: title,
                description: description,
                ogimage: ogimage,
                url: self.inputUrl,
                timestamp: Date.parse(new Date())
              }).then(function () {
                self.message = title + " を登録しました"
                self.inputUrl = ""
                db.ref('/articles').once('value').then(function (articles) {
                  let _articles = articles.val()
                  for (let index in _articles) {
                    self.articles.push(_articles[index])
                  }

                  self.articles = self.articles.reverse()
                })
                self.articles = []
              })

          })

        }

      }
    }
  }
</script>
